// Overtime roster — the current employee list, imported from the "yperwries_rolodex" workbook and
// kept in the sheet's own order (each name's position drives the number printed on its card). This is
// the standard list offered in the UI and seeded into D1 on deploy.
export const OVERTIME_DEFAULT_NAMES = [
    "AHSAN AHTAZAZ - TAJI",
    "SHEHI ARMODI",
    "FOYRARI VIOLTSA-ΒΙΟΛΑ",
    "GALINA",
    "LOSHA DANJEL-ΗΡΑΚΛΗΣ",
    "POPA ALEKSANDER",
    "SHEHI BILBIL-BILL",
    "SHEHI FLORESHA",
    "SHEHI IMIRLIND",
    "SHEHI SPETIM-ΤΟΛΗΣ",
    "VELI ILIR-ΗΛΙΑΣ",
    "BIZGJONI LAERT",
    "ΒΙΚΤΩΡΑΣ ΠΙΛΙΠΙΟΥΚ",
    "ΒΟΛΥΡΑΚΗΣ ΔΗΜΗΤΡΗΣ",
    "ΒΟΛΚΟΒ ΛΕΒ",
    "ΒΟΛΚΟΒΑ ΕΛΕΝΗ",
    "ΒΡΟΥΤΣΗΣ ΜΙΧΑΛΗΣ",
    "ΓΕΩΡΓΙΟΥ ΧΑΡΑΛΑΜΠΟΣ",
    "ΓΡΑΜΜΑΤΙΚΟΣ ΘΑΝΑΣΗΣ",
    "ΕΡΜΙΔΗΣ ΓΕΩΡΓΙΟΣ",
    "ΖΙΑΚΑ ΕΥΑΓΓΕΛΙΝΗ",
    "ΙΓΝΑΤΙΑΔΗΣ ΑΝΔΡΕΑΣ",
    "ΚΑΚΚΟΣ ΡΑΦΑΗΛ",
    "ΚΟΛΛΙΑΣ ΓΙΩΡΓΟΣ",
    "ΚΟΝΤΑΚΟΣ ΙΩΑΝΝΗΣ",
    "ΚΥΡΙΑΚΙΔΗΣ ΓΙΩΡΓΟΣ",
    "ΚΩΣΤΑΝΤΙΝΟΥ ΠΑΝΑΓΙΩΤΗΣ",
    "ΚΩΣΤΟΛΟΓΟΥ ΘΕΟΔΩΡΟΣ",
    "ΛΟΪΖΟΣ ΓΙΑΝΝΗΣ",
    "ΛΟΥΚΑΣ ΓΕΩΡΓΙΟΣ",
    "ΜΑΝΤΑΣ ΠΑΝΤΕΛΕΗΜΩΝ",
    "ΜΕΜΕΤ ΑΝΙΦΕ",
    "ΜΕΜΕΤ ΗASAN-ΑΚΗΣ",
    "ΜΗΤΡΟΓΙΑΝΝΗΣ ΜΑΝΩΛΗΣ",
    "ΜΟΥΡΑΒΤΣΕΝΚΟ ΒΙΤΑΛΙ",
    "ΜΩΡΑΚΟΣ ΓΕΩΡΓΙΟΣ",
    "ΝΑΖΑΡΟΒ ΝΤΕΝΙΣ",
    "ΝΙΚΟΛΑΪΔΗΣ ΠΑΥΛΟΣ",
    "ΝΤΕΝΤΕΣ ΓΙΑΝΝΗΣ",
    "ΝΤΡΕΟΥ ΘΑΝΟΣ",
    "ΠΑΣΧΑΛΗ ΠΑΝΑΓΙΩΤΑ",
    "ΠΙΤΣΙΚΑΛΗ ΛΙΤΣΑ",
    "ΡΑΓΚΟΥΣΗΣ ΑΘΑΝΑΣΙΟΣ",
    "ΡΟΥΜΠΑΝΗΣ ΑΝΤΩΝΙΟΣ",
    "ΣΑΡΗΓΙΑΝΝIΔΗΣ ΣΤΑΥΡΟΣ",
    "ΣΤΑΜΠΟΥΛΟΣ ΑΝΤΡΕΑΣ",
    "ΨΥΚΟΣ",
    "ΤΕΡΕΖΑΚΗ ΣΤΑΥΡΟΥΛΑ",
    "ΤΣΟΥΠΙ ΚΡΙΣΤΙΑΝ",
    "ΤΣΟΥΚΑΤΟΣ ΚΩΣΤΑΣ",
    "ΧΡΗΣΤΑΚΟΣ ΓΙΩΡΓΟΣ",
    "ΧΡΗΣΤΟΥ ΓΙΑΝΝΗΣ",
    "ISIU ELVIS",
    "ΜΙΧΑΗΛΙΔΗΣ ΘΕΟΔΩΡΟΣ",
    "ΔΙΑΜΑΝΤΟΠΟΥΛΟΥ ΕΥΑΓΓΕΛΙΑ",
    "PLAKHOTNIUK",
    "ΒΥΛΛΙΩΤΗΣ ΜΙΧΑΛΗΣ",
    "ΚΑΛΥΒΙΑΝΑΚΗΣ ΟΡΕΣΤΗΣ",
    "ΚΥΡΙΑΚΑΚΗΣ ΑΝΔΡΕΑΣ",
];
//# sourceMappingURL=overtime.js.map